export default function currencyFormatter(code, value, decimals) {
  if (code && code !== 'undefined') {
    const options = { currency: code, style: 'currency' }
    if (decimals !== undefined) {
      options.minimumFractionDigits = decimals
      options.maximumFractionDigits = decimals
    }
    const formatter = new Intl.NumberFormat('ru-RU', options)
    return formatter.format(value)
  }

  return ''
}
